import * as React from "react";
const SvgRegistryWhite = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} fill="none" {...props}>
    <g fill="#fff" fillRule="evenodd" clipRule="evenodd">
      <path d="M8.2 15.744a.8.8 0 0 1 .8-.8h22a.8.8 0 0 1 0 1.6H9a.8.8 0 0 1-.8-.8" />
      <path d="M12.3 27.8V15.526h-1.6V27.9a1.5 1.5 0 0 0 1.5 1.5h15.6a1.5 1.5 0 0 0 1.5-1.5V15.526h-1.6V27.8z" />
      <path d="M22.196 11.504c1.312-1.744 4.078-1.788 5.275.167q.077.123.153.28.06.122.117.269l.001.002c.823 2.13-.874 4.322-3.053 4.322h-6.294zm3.91 1.003c-.55-.9-1.933-.97-2.632-.04l-1.869 2.477h3.084c1.152 0 1.944-1.152 1.561-2.145a2 2 0 0 0-.07-.16 1 1 0 0 0-.073-.13z" />
      <path d="M16.529 12.466c-.7-.93-2.081-.86-2.632.041l-.002.002a1 1 0 0 0-.071.13 2 2 0 0 0-.071.16c-.383.993.409 2.145 1.56 2.145h3.084zm1.278-.962c-1.312-1.744-4.078-1.788-5.275.167q-.077.123-.153.28-.06.122-.118.269v.002c-.824 2.13.874 4.322 3.053 4.322h6.294z" />
      <path d="M19.2 28.6V15.425h1.6V28.6z" />
    </g>
  </svg>
);
export default SvgRegistryWhite;
